import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const IntegrationPreview = ({ name, logo, logoAlt, status, description, isConnected }) => {
  return (
    <div className={`p-4 rounded-lg border transition-all duration-200 ${
      isConnected 
        ? 'border-success bg-success/5' :'border-border bg-card hover:border-accent/50'
    }`}>
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-lg overflow-hidden bg-white p-1">
            <Image 
              src={logo} 
              alt={logoAlt}
              className="w-full h-full object-contain"
            />
          </div>
          <div>
            <h4 className="font-semibold text-foreground text-sm">{name}</h4>
            <p className="text-xs text-muted-foreground">{status}</p>
          </div>
        </div>
        
        {isConnected ? (
          <div className="flex items-center gap-1 text-success">
            <Icon name="CheckCircle2" size={16} />
            <span className="text-xs font-medium">Подключено</span>
          </div>
        ) : (
          <div className="flex items-center gap-1 text-muted-foreground">
            <Icon name="Circle" size={16} />
            <span className="text-xs">Доступно</span>
          </div>
        )}
      </div>
      
      <p className="text-xs text-muted-foreground">{description}</p>
    </div>
  );
};

export default IntegrationPreview;